import { ErrorComponent } from "@/components/Error/ErrorComponent";
import { ViewportLoader } from "@/components/Loading";
import { routeTree } from "@/routeTree.gen";
import type { RouteIds } from "@tanstack/react-router";
import {
  createRouter,
  parseSearchWith,
  stringifySearchWith,
} from "@tanstack/react-router";
import { parse, stringify } from "jsurl2";
import { queryClient } from "./queryClient";

/**
 * Register the router instance for type safety
 * @see https://tanstack.com/router/v1/docs/framework/react/api/router/RegisterType
 */
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

/**
 * Routerインスタンスをセットアップ
 * @see https://tanstack.com/router/latest/docs/framework/react/api/router/createRouterFunction#createrouter-function
 */
export const router = createRouter({
  routeTree,
  /**
   * クエリパラメータのデフォルト値が設定されているRouteにおいて、
   * パラメータを空にしてURLに直アクセスすると、画面が表示されない問題の対応
   * @see: https://github.com/TanStack/router/issues/2031#issuecomment-2255504750
   */
  defaultPendingMinMs: 0,
  // loaderがpendingComponentを表示するまでの待機時間をデフォルトの1000msから200msに設定
  defaultPendingMs: 200,
  defaultPendingComponent: ViewportLoader,
  defaultErrorComponent: ErrorComponent,
  context: {
    queryClient,
  },
  // @see https://tanstack.com/router/latest/docs/framework/react/guide/custom-search-param-serialization#using-the-jsurl2-library
  parseSearch: parseSearchWith(parse),
  stringifySearch: stringifySearchWith(
    (obj) => stringify(obj, { rich: true }),
    parse,
  ),

  scrollRestoration: true,

  // スクロールの動作を設定
  defaultHashScrollIntoView: {
    behavior: "smooth",
    block: "start",
  },
  // mainコンテンツのネストされたスクロール可能エリアもスクロール対象に含める
  scrollToTopSelectors: [".overflow-y-auto", ".overflow-auto"],
});

export type RouterType = typeof router;
export type RouterIds = RouteIds<RouterType["routeTree"]>;
